import { http } from 'services';

export function getSchedules(type, id, dayID, cbSuccess, cbError) {
  http.get(
    `${type}/${id}/days/${dayID}/schedules`,
    {},
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

export function getSchedule(type, id, dayID, scheduleID, cbSuccess, cbError) {
  http.get(
    `${type}/${id}/days/${dayID}/schedules/${scheduleID}`,
    {},
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

export function addSchedule(type, id, dayID, data, cbSuccess, cbError) {
  http.post(
    `${type}/${id}/days/${dayID}/schedules`,
    data,
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

export function editSchedule(type, id, dayID, scheduleID, data, cbSuccess, cbError) {
  http.patch(
    `${type}/${id}/days/${dayID}/schedules/${scheduleID}`,
    data,
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

export function removeDaySchedules(type, id, dayID, cbSuccess, cbError) {
  http.delete(
    `${type}/${id}/days/${dayID}/schedules`,
    {},
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

export function removeSchedule(type, id, dayID, scheduleID, cbSuccess, cbError) {
  http.delete(
    `${type}/${id}/days/${dayID}/schedules/${scheduleID}`,
    {},
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

export function getScheduleSummaryPrediction(type, id, dayID, params, cbSuccess, cbError) {
  http.get(
    `${type}/${id}/days/${dayID}/summary-prediction`,
    params,
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

export function updateSchedulesSequence(type, id, dayID, payload, cbSuccess, cbError) {
  http.post(
    `${type}/${id}/days/${dayID}/schedules/update-sequence`,
    payload,
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

export function updateComplexScheduleSequence(type, id, dayID, scheduleID, payload, cbSuccess, cbError) {
  http.post(
    `${type}/${id}/days/${dayID}/schedules/${scheduleID}/update-sequence`,
    payload,
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}



// WEBPACK FOOTER //
// ./src/api/api-programs/api-programs-schedule.js